import SpriteEngine from '../SpriteEngine/SpriteEngine'
import type Particle from '../Particle/Particle'

export default class ParticleEngine extends SpriteEngine {
  public static particleCount = 0

  /**
   * Particle-k hozzáadása.
   * @param items - Particle tömb.
   */
  public override add (...items: Particle[]): void {
    const { particleCount } = ParticleEngine

    ParticleEngine.particleCount = particleCount + items.length
    this.items.push(...items)
  }

  /** Particle-ok törlése. */
  public override clear (): void {
    const { particleCount } = ParticleEngine

    ParticleEngine.particleCount = particleCount - this.items.length

    this.items = []
  }
}
